import { Locale } from 'helpers/Enums';
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";

interface IProps {
    value?: Locale | string
}

let LanguageLabel = ({ value }: IProps) => {
    let { formatMessage } = useIntl();
    switch (value as Locale) {
        case Locale.Italian: return (<span>{formatMessage({ id: LocalizationIds.Italian })}</span>);
        case Locale.English: return (<span>{formatMessage({ id: LocalizationIds.English })}</span>);

        default: return (<span></span>)
    }
}

export default LanguageLabel;